var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return this.$root.token
    ? _c(
        "b-container",
        [
          _c("br"),
          _vm._v(" "),
          _c("h3", [_vm._v("Group Performance Coaching (GPC) Sessions")]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c(
            "b-tabs",
            {
              model: {
                value: _vm.tabIndex,
                callback: function($$v) {
                  _vm.tabIndex = $$v
                },
                expression: "tabIndex"
              }
            },
            [
              _c(
                "b-tab",
                { attrs: { title: "Search GPC Sessions" } },
                [
                  _c("g-p-c-search", {
                    on: {
                      "edit-gpc": function($event) {
                        _vm.gpcToEdit = $event
                        _vm.tabIndex = 1
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                { attrs: { title: "Enter GPC Session" } },
                [
                  _c("g-p-c-add", {
                    attrs: { gpcSessionToEdit: _vm.gpcToEdit }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-19851b8d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19851b8d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/GPCSessions.vue
// module id = null
// module chunks = 